import { registerPropertyManagerSection, type PropertyManagerContext } from '@/core';
import PathLengthDimensionPropertySection from '@/components/editor/property-manager/smart-dimension/PathLengthDimensionPropertySection.vue';
import type { Viewer } from '@puppycad/cad-core';

/** 读取 viewer 句柄。 */
function resolveViewer(context: PropertyManagerContext): Viewer | null {
  return (context.renderer as Viewer | null) ?? null;
}

registerPropertyManagerSection({
  id: 'sketch-path-length-dimension',
  title: '路径长度',
  order: 16,
  component: PathLengthDimensionPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  // 链未合法（断链/不足两段）时禁用确认；confirm 内部仍有校验兜底报错。
  resolveConfirmDisabled: (context) => {
    const candidate = resolveViewer(context)?.getSmartDimensionSnapshot?.()?.candidate ?? null;

    return candidate?.dimensionKind !== 'path-length';
  },
  isApplicable: (context) => context.isSketchActive === true
    && context.activeCommand === 'sketch-path-length-dimension',
  onConfirm: (context) => {
    void resolveViewer(context)?.sketchSmartDimensionController?.confirmPathLengthSelection();
  },
  onCancel: (context) => {
    // 控制器退出后快照转 inactive，宿主订阅会双向收口 workflow 工具栏状态。
    resolveViewer(context)?.cancelSketchSmartDimensionMode?.();
  },
});
